import type { HexColor } from '@getaccept/fried-tofu';
import { BackgroundType } from '@getaccept/lib-shared/src/branding/types/enums/background-type';
import { fallbackTextContent } from '@getaccept/editor-lib';
import type { HeroSection } from '../types/hero-section';
import { HeroSectionLayoutOrder } from '../types/enums/hero-section-layout-order';
import { HeroSectionLayout } from '../types/enums/hero-section-layout';
import { HeroSectionMediaType } from '../types/enums/hero-section-media-type';
import { HeroSectionImageSize } from '../types/enums/hero-section-image-size';

export default class HeroSectionConstants {
  static defaultWidgetHeight = '555px';
  static defaultBackgroundColor: HexColor = '#F8FAFC';
  static emptyState = (): HeroSection => ({
    textWidgetBackgroundColor: '#FFFFFF',
    background: {
      gradientColorOne: this.defaultBackgroundColor,
      gradientColorTwo: '#B0C7DD',
      gradientLightness: 0,
      type: BackgroundType.GradientSolid,
      imageId: '',
    },
    text: fallbackTextContent,
    fields: [],
    layoutOrder: HeroSectionLayoutOrder.TextLeftMediaRight,
    layout: HeroSectionLayout.TextAndMedia,
    media: {
      type: HeroSectionMediaType.Image,
      imageId: '',
      fullWidth: false,
      imageSize: HeroSectionImageSize.Original,
    },
  });
}
